import { render } from "./teachStudioManage.vue?vue&type=template&id=4cb5f73d&scoped=true"
import script from "./teachStudioManage.vue?vue&type=script&lang=js"
export * from "./teachStudioManage.vue?vue&type=script&lang=js"

import "./teachStudioManage.vue?vue&type=style&index=0&id=4cb5f73d&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cb5f73d"]])

export default __exports__